<div *ngIf="errorMessage" class="cand-modal">
    <article [@slideInOut] class="cand-modal__overlay cand-modal__overlay--centered">
        <h1 class="cand-modal__title">{{ title }}</h1>
        <section class="cand-modal__content cand-modal__content--error">{{ errorMessage }}
            <div *ngIf="errorCodeMessage" class="errorCodeMessage">{{ errorCodeMessage }}</div>
        </section>
        <button class="button button--primary" (click)="close()">{{ closebutton }}</button>
    </article>
    <div [@fadeInOut] class="cand-modal__fade" (click)="close()"></div>
</div>
